const SUFFIX_LEN = 5;

/**
 * Label for the AI audit "Instance" link: `...` + last 5 characters of
 * `instanceId` (or the full value when it is at most 5 characters).
 */
export function instanceIdLinkLabel(
  instanceId: string | null | undefined,
): string {
  if (instanceId == null) {
    return 'View';
  }

  const s = instanceId.trim();
  if (s.length === 0) {
    return 'View';
  }

  if (s.length <= SUFFIX_LEN) {
    return s;
  }

  return `...${s.slice(-SUFFIX_LEN)}`;
}
